import type { useTranslations } from 'next-intl';
import { SITE } from '@/app/constants';
import type { SupportedLanguage } from '@/app/types';

export const getHeaderTabsConfig = (t: ReturnType<typeof useTranslations<'header'>>, locale: SupportedLanguage) => [
  {
    label: t('tabs.features.label'),
    key: 'features',
    href: '',
    icon: '',
    children: [
      {
        label: t('tabs.features.vidu-q3'),
        key: 'vidu-q3',
        href: '/vidu-q3',
      },
      {
        label: t('tabs.features.reference'),
        key: 'character2video',
        href: '/create/character2video',
      },
      {
        label: t('tabs.features.image'),
        key: 'img2video',
        href: '/create/img2video',
      },
      {
        label: t('tabs.features.text'),
        key: 'text2video',
        href: '/create/text2video',
      },
      {
        label: t('tabs.features.reference-to-image'),
        key: 'reference-to-image',
        href: '/create/reference2image',
      },
      {
        label: t('tabs.features.text-to-image'),
        key: 'text-to-image',
        href: '/create/text2image',
      },
      {
        label: t('tabs.features.vidu-claw'),
        key: 'vidu-claw',
        href: '/vidu-claw',
      },
      {
        label: t('tabs.features.ai-tools'),
        key: 'ai-tools',
        href: '/create/tools',
      },
      {
        label: t('tabs.templates.label'),
        key: 'Templates',
        href: '/templates',
      },
    ],
  },
  {
    label: t('tabs.features.vidu-stream'),
    key: 'vidu-stream',
    icon: '',
    href: '/vidu-stream',
  },
  {
    label: t('tabs.pricing.label'),
    key: 'Pricing',
    icon: '',
    href: '/pricing',
  },
  {
    label: t('tabs.api.label'),
    key: 'api',
    icon: '',
    href: SITE === 'china' ? 'https://platform.vidu.cn/' : 'https://platform.vidu.com/',
  },
  SITE === 'china' && {
    label: t('tabs.creatorPlan.label'),
    key: 'artistProgram',
    icon: '',
    href: '/artist-program',
  },
  SITE === 'global' && {
    label: t('tabs.creatorPlan.label'),
    key: 'creatorPlan',
    icon: '',
    href: '',
    children: [
      {
        label: t('tabs.creatorPlan.viduCPP'),
        key: 'viduCPP',
        href: '/artist-program',
      },
      {
        label: t('tabs.creatorPlan.viduEarn'),
        key: 'viduEarn',
        href: '/vidu-earn',
      },
    ],
  },
  {
    label: t('tabs.about.label'),
    key: 'about',
    href: '',
    icon: '',
    children: [
      {
        label: t('tabs.support.helpCenter'),
        key: 'Help Center',
        href: '/help-center',
      },
      {
        label: t('tabs.support.tutorial'),
        key: 'Tutorial',
        href: '/home/tutorial',
      },
      {
        label: t('tabs.joinUs.label'),
        key: 'joinUs',
        href: 'https://shengshu.jobs.feishu.cn/index/',
      },
      ['en', 'ja'].includes(locale) && {
        label: t('tabs.support.aiTemplates'),
        key: 'AI Templates',
        href: '/ai-templates',
      },
      ['en', 'ja'].includes(locale) && {
        label: t('tabs.support.blog'),
        key: 'Blog',
        href: '/blog',
      },
    ],
  },
];
